function u(e,r){if(!Number.isInteger(e)||e<0)throw new Error("n must be a non-negative integer.");let n=0;return(...t)=>{if(++n>=e)return r(...t)}}export{u as after};
